export default {
    init() {
        

		/**
		* Potrditev prijave restavracije
		**/
        $('#prijava-1-form').on('submit', function(e) {
            e.preventDefault()

            let this_form = $(this)

            let formData = this_form.serialize()

			let submitBtn = this_form.find('button[type="submit"]')
			submitBtn.prop('disabled', true)

			$.ajax({
				url: my_ajax_object.ajax_url,
				type: 'POST',
				dataType: 'json',
				data: formData + '&action=potrditev_prijave_restavracije',
				success: function (response) {
                    if (response && response.success) {
						window.location.reload()
					} else {
						alert(response.data.message)
						submitBtn.prop('disabled', false)
					}
				},
				error: function() {
					alert('Prišlo je do napake pri pošiljanju. Preverite, ali ste vpisali pravilno povezavo v brskalnik in poskusite znova.')
					submitBtn.prop('disabled', false)
				}
			})
        })



    }
}